import { isDispatcherUrl } from 'modules/utils/UrlUtils';
import { SUCCESS_SUFFIX } from '../../lib/constants/network';

export const axiosMiddlewareSuccessOverride = ({ action, next, response }: any, options?: any) => {
  const uri = response?.config?.baseURL || response?.config?.url;
  const payload =
    !!response?.data?.data && isDispatcherUrl(uri)
      ? {
          ...response,
          data: response.data.data,
          partialErrors: response.data.errors,
          source: response.data.source,
          urlHash: response.data.urlHash
        }
      : response;

  const nextAction = {
    meta: {
      previousAction: action
    },
    payload,
    type: `${action.type}${SUCCESS_SUFFIX}`
  };

  next(nextAction);
  return nextAction;
};
